import { Button, Card, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../template/store";
import { IDataTableColumn } from "../../common/types/dataTable";
import {
  getCustomersDetailsByPartnerId,
  fetchLinerNameByCountry,
} from "../profile/action/ProfileAccount";
import { Link, matchPath, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import {
  faSave
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { faArrowAltCircleLeft, faEdit } from "@fortawesome/free-regular-svg-icons";
import CustomerCodeRequestTable from "./CustomerCodeRequestTable";
import { AESDecrypt } from "../../../encrypt-util";
import useDataCountry from "../../../hooks/useDataCountry";
import { clearCustomerMappingReqFiles, resetPartenerTable, setPartnerTableRow } from "./CustomerCodeSlice";
import ToggleDiv from "../../../components/common/ToggleDiv";
import { toast } from "react-toastify";
import { submitCustomerCodeRequest } from "./CustomerCodeAction";
import { updateDashbaordRefresh } from "../../common/components/DataTable/slices/DataTable";


const CustomerCodeRequest = () => {
  const location = useLocation();
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const { requestID } = useParams();
  const requestIDDecrypt = AESDecrypt(requestID) ?? '';

  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  //Close Profile account
  const _onCloseForm = () => {
    navigate(`${APP_PATH_PREFIX}/customerCode`);
  };
  const dataCountry = useDataCountry();

  //common method for table
  const partnerData = useSelector((state: RootState) => state.partnerData);
  const rbac = useSelector((state: RootState) => state.userProfile);

  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );

  const tableData = useSelector((state: RootState) => state.customerCodeRequest.partnerTable)

  const linerOptions = useSelector(
    (state: RootState) => state.customerCodeRequest.linerOptions
  );


  //partner Name
  const [companyName, setCompanyName] = useState("");

  const isDataTableDisabled = (requestIDDecrypt) || (profileDetails?.partnerType == 'liner');

  const isFileUploading = tableData?.some(
    (row) => row.loading != 100 && row.loading != -1 && row.loading != undefined && row.loading != 0
  );

  const hasMandatoryDocNotUploaded = tableData?.some(
    (row) => row.m && (row.loading !== 100 || row.serverPath == null)
  );

  const validateCustomerCodeRequestTable = (tableData: any[]) => {
    let hasErrors = false;

    const updatedErrors = tableData?.map(row => {
      const attachmentError =
        row.m && (row.serverPath == null || row.loading !== 100);

      const customerCodeError =
        row.customerCode.trim() === "";

      if (attachmentError || customerCodeError) {
        hasErrors = true;
      }

      return {
        rowNumber: row.rowNumber,
        error: {
          attachment: attachmentError,
          customerCode: customerCodeError
        }
      };
    });

    return { hasErrors, updatedErrors };
  };


  // const hasDuplicateLinerCustomerCode = (tableData: any[]) => {
  //   return tableData?.some((row, index) =>
  //     tableData?.find(
  //       (r, i) =>
  //         i != index &&
  //         r.liner == row.liner &&
  //         r.customerCode.trim() == row.customerCode.trim()
  //     )
  //   );
  // };

  const hasDuplicateLinerCustomerCode = (tableData: any[]) => {
    const map = new Map<any, Set<string>>();

    for (const row of tableData) {
      if (!row?.liner || !row?.customerCode) continue;

      const codes = map.get(row.liner) || new Set<string>();
      if (codes.has(row.customerCode.trim())) return true;

      codes.add(row.customerCode.trim());
      map.set(row.liner, codes);
    }

    return false;
  };


  const onSubmitForm = (e: any) => {

    const { hasErrors, updatedErrors } = validateCustomerCodeRequestTable(tableData);

    updatedErrors.forEach(row => {
      dispatch(setPartnerTableRow(row));
    });

    if (!!hasErrors) {
      toast.error("Please fill in all fields before submitting");
      return;
    }

    const hasDuplicateEntries = hasDuplicateLinerCustomerCode(tableData)

    if (!!hasDuplicateEntries) {
      toast.error("Duplicate liner and customer code combination found");
      return;
    }


    const payload = tableData?.map(row => ({
      rowNumber: row.rowNumber,
      linerId: Number(row.liner),
      mapCode: row.customerCode,
      tempFilePath: row.serverPath ?? "",
      tempFileName: row.serverName ?? "",
      fileName: row.attachmentName ?? ""
    }));

    dispatch(submitCustomerCodeRequest(payload))
      .unwrap()
      .then((res) => {
        if (res.status == "ERROR") {
          toast.error("Please fix errors highlighted below")
        } else if (res.status == "SUCCESS") {
          toast.success("Customer Code Request Submitted")
          navigate('/customerCode')
        }
        setTimeout(() => {
          dispatch(updateDashbaordRefresh(true))
        }, 2000);
      })
      .catch((err) => {
        toast.error("Failed to submit. Please try again.");
        console.error(err);
      })
  };

  useEffect(() => {
    dispatch(resetPartenerTable())
    dispatch(clearCustomerMappingReqFiles());


    dispatch(getCustomersDetailsByPartnerId({}))
      .unwrap()
      .then((response: any) => {
        setCompanyName(response.companyName);
        if (
          response.mstPartnerId !== undefined ||
          response.mstPartnerId !== null
        ) {
          // if (customerMappingList.length == 0) {
          //   setCustomerMappingList(
          //     response.customermappingList.list.map((v: any) => ({
          //       customerMapId: v?.customerMapId,
          //       customerId: v?.customerId,
          //       linerId: v?.linerId,
          //       mapCode: v?.mapCode,
          //       internalCode: v?.internalCode,
          //       readonly: true,
          //     }))
          //   );
          // }
        }
      });
  }, []);

  return (
    <Card style={{ height: '100%', overflow: 'auto' }}>
      <Card.Header className="d-flex align-items-center border-bottom">
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className="cursor-pointer fa-lg mb-1 me-1 justify-content-start"
          onClick={_onCloseForm}
        />
        <h2 className="fs-0 text-primary mb-1">Customer Code Request</h2>
      </Card.Header>
      <Card.Body>
        <div className="container-fluid">

          {/* <div className="h2 text-secondary fs-0 pb-3 border-bottom">
            {t("resource_2:companyDetails")}
          </div> */}
          <div className="row">
            <div className="col-lg-6 mb-3">
              <Form.Group controlId="customerCodeReq.companyName">
                <Form.Label className="fs--1">{t("resource_2:companyname")}</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e) => setCompanyName(e.target.value)}
                  size="sm"
                  disabled={true}
                  value={companyName}
                />
              </Form.Group>
            </div>
          </div>

          {/*customer mapping*/}
          {(partnerData.data.mstPartnerId && profileDetails.partnerType == 'customer') && (
            <div className="row g-0 h-100 flex-1 ">
              <CustomerCodeRequestTable
                country={dataCountry}
                isDataTableDisabled={isDataTableDisabled}
                // disableAttach={location.pathname.includes("request") && requestIDDecrypt}
                requestId={requestIDDecrypt}
                isFileUploading={isFileUploading}
              />
            </div>
          )}

          <div className='d-flex justify-content-center align-items-center'>
            {!(
              (profileDetails.partnerType === 'customer' && !!requestIDDecrypt) ||
              profileDetails.partnerType === 'liner'
            ) && rbac.rbacDetails.submitCustomerCodeReq == "Y" && (
                <Button
                  className='me-2'
                  variant='falcon-primary'
                  size='sm'
                  data-placement="left"
                  data-toggle="tooltip"
                  onClick={onSubmitForm}
                  style={{ marginRight: '0.5rem', position: 'relative' }}
                  disabled={!(linerOptions?.length > 0) || isFileUploading}
                >
                  <FontAwesomeIcon icon={faSave} className='mx-1 me-2 mt-1 text-warning' />
                  <span>Submit</span>
                </Button>
              )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CustomerCodeRequest;
